import { Component, OnInit } from '@angular/core';
import { MentorService } from 'src/app/services/mentor.service';

@Component({
  selector: 'app-students',
  templateUrl: './students.component.html',
  styleUrls: ['./students.component.scss']
})
export class StudentsComponent implements OnInit {
  public students=[];
  public loading:boolean=true;
  public loadingPractices:boolean=true;
  public practices=[];

  constructor(
    private _mentor: MentorService
  ) { }

  public getStudents(){
    this._mentor.getStudents().subscribe(
      res=>{
        this.students=res;
        this.loading=false;
      }
    );
  }

  public getMentorPractices(){
    this._mentor.getPractices().subscribe(
      res=>{
        this.practices=res;
        this.loadingPractices=false;
      }
    );
  }

  public removeStudent(id:number){
    if(confirm('Confirm removal of this student?')){
      this._mentor.removeStudent(id).subscribe(
        res=>{
          this.getStudents();
        }
      );
    }
  }

  ngOnInit() {
    this.getStudents();
    this.getMentorPractices();
  }

  public removeMentoring(practice_id:number, mentor_id:number) {
    if(confirm('Cnofirm you want to stop mentoring this practice and all related users')) {
      this._mentor.removeMentor(practice_id, mentor_id).subscribe(
        res=>{
          this.getStudents();
          this.getMentorPractices();
        }
      );
    }
  }
}
